import type { PropsWithChildren } from 'react';

interface ConditionalFieldProps {
	isVisible: boolean;
}

export const ConditionalField: React.FC<PropsWithChildren<ConditionalFieldProps>> = ({ children, isVisible }) => {
	if (!isVisible) {
		return null;
	}

	return <>{children}</>;
};
